import {RestDataLoader} from "../../../dashboard/widgets/unilever/RestDataLoader";
import {VeboxModels} from "../../../types/veboxModels";
import {JSONEquipmentImagesConfiguration} from "./EquipmentImages";

export class EquipmentImagesController {
    public static retrieveBarcaImages(equipmentGuid: string) {
        return new Promise<any>((res, rej) => {
            RestDataLoader.loadData(
                "equipment/" + equipmentGuid + "/barca/data/last",
                null,
                res,
                rej,
            );
        })
    }

    public static retrievePlantImages(equipmentGuid: string) {
        return new Promise<any>((res, rej) => {
            RestDataLoader.loadData(
                "equipment/" + equipmentGuid + "/photos",
                null,
                res,
                rej,
            );
        })
    }

    public static removePlantImages(photoGuid: string, equipmentGuid: string) {
        return new Promise<any>((res, rej) => {
            RestDataLoader.deleteJSON(
                "equipment/" + equipmentGuid + "/photos/" + photoGuid,
                null,
                res,
                rej
            );
        })
    }

    public static uploadPlantImages(image: any, equipmentGuid: string) {
        const data = new FormData()
        data.append("image", image)
        data.append("guid", equipmentGuid)

        const imageURl = `${RestDataLoader.getBaseUrl()}v7/equipment/${equipmentGuid}/photos`;
        return RestDataLoader.fetchWithAuthentication(
            imageURl,
            RestDataLoader.getCurrentToken(),
            {
                method: "POST",
                body: data
            }
        )
    }

    public static getCurrentUser() {
        return new Promise<VeboxModels.User>((res, rej) => {
            RestDataLoader.loadData(
                "users/current",
                null,
                (result: VeboxModels.User) => {
                    res(result);
                },
                rej,
            );
        })
    }

    public static retrieveConfiguration(equipmentId: number): Promise<JSONEquipmentImagesConfiguration> {
        const url = "equipment/" + equipmentId + "/images";
        return new Promise<JSONEquipmentImagesConfiguration>((res, rej) => {
            Ajax.ajaxRequestForJson(
                {
                    url,
                    type: "GET",
                    success: (val) => {
                        res(val)
                    },
                    error: rej
                },
            );
        })
    }
}